module.exports = "<app-searchfilters-photo></app-searchfilters-photo> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/home/photo/partial.html
// module id = 415
// module chunks = 0